import React from 'react';
import { Outlet } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';

function AppRoute() {
  return (
    <>
      <CssBaseline />
      <Outlet />
    </>
  );
}

export default AppRoute;
